import React, { useState, useEffect, useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import './Destinations.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faHotel,
  faCar,
  faPersonHiking,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";

const Destinations = () => {
  const [destinations, setDestinations] = useState([]);
  const carouselRef = useRef(null);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}AllDestination`
        );
        const data = await response.json();
        if (data.status === "true") {
          setDestinations(data.data);
        } else {
          console.error("Error fetching data:", data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  // Navigation handlers
  const handlePrevious = () => {
    carouselRef.current?.previous();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  // Responsive settings for carousel
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };

  return (
    <div className="container-fluid">
      <div className="text-center mt-5 mb-4">
        <h2
          className="mb-5"
          style={{
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "42px",
            lineHeight: "100%",
            letterSpacing: "0%",
            textAlign: "center",
            verticalAlign: "middle",
            textTransform: "capitalize",
          }}
        >
          Our Destinations Ladakh
        </h2>
      </div>

      {/* Carousel Container with Navigation */}
      <div className="carousel-wrapper position-relative">
        {/* Previous Button */}
        <button
          onClick={handlePrevious}
          className="carousel-nav-btn carousel-prev-btn"
          aria-label="Previous slide"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>

        {/* Next Button */}
        <button
          onClick={handleNext}
          className="carousel-nav-btn carousel-next-btn"
          aria-label="Next slide"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>

        <Carousel
          responsive={responsive}
          className="pb-0"
          ref={carouselRef}
          arrows={false}
          draggable={true}
          swipeable={true}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3000}
          pauseOnHover={true}
          grabCursor={true}
        >
          {destinations.map((destination) => (
            <div key={destination.id} className="destination-slide mx-3">
              <div className="image-container">
                <img
                  src={destination.Image}
                  alt={`${destination.Name} image`}
                  className="destination-image"
                />
                <div className="glass-overlay-Dest text-white">
                  <div className="d-flex justify-content-between align-items-center">
                    <h3 className="text-white mb-0 font-bold"  style={{ fontSize: '23px' }}>
                      {destination.Name}
                    </h3>
                  </div>
                  <div
                    className="text-white destination-details text-decoration-none"
                    dangerouslySetInnerHTML={{ __html: destination.Details }}
                  />
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>

      <div className="text-center mt-3">
        <NavLink to="/all-destinations">
          <button
            className="px-4 py-2"
            style={{
              backgroundColor: "black",
              color: "white",
              fontWeight: "bold",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            View All
          </button>
        </NavLink>
      </div>
    </div>
  );
};

export default Destinations;